import React from 'react';
import styled from 'styled-components';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import { Helmet } from 'react-helmet';
import * as R from 'ramda';
import { Box, Flex, Card, Link } from '@cowsquare/design';
import { useAdsQuery } from '../../../../utils/hooks';
import { Advertisements } from '../../../Advertisements';
import { Section } from '../../../Section';
import { Title } from '../../../Title';
import { Loading, LinkCardListLoading } from '../../../Loading';

const SubTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  line-height: 1.5;
  font-weight: normal;
`;

const CardFlex = styled(Flex).attrs({
  flexWrap: 'wrap',
})`
  margin: 0 -8px;
`;

const GET_CME_LINKS = gql`
  query {
    list: hkdutest_cme_useful_links_categories {
      id
      name
      links {
        id
        url
        name
      }
    }
  }
`;

const Links = ({ uri }) => {
  const { data, loading } = useQuery(GET_CME_LINKS);
  const categories = R.propOr([], 'list', data);
  const { ads } = useAdsQuery(uri);

  return (
    <Section>
      <Helmet>
        <title>Useful Links - HKDU CME</title>
      </Helmet>
      <Advertisements ads={ads} />
      <Box width="100%" px={['20px', 0]} py={8}>
        <Flex flexDirection="column">
          <Title>Useful Links</Title>
          {loading ? (
            <React.Fragment>
              <Box mt={25} mb={20}>
                <Loading width="120px" height="12px" />
              </Box>
              <LinkCardListLoading />
            </React.Fragment>
          ) : (
            R.map(category => (
              <React.Fragment key={category.id}>
                <Box mt={25} mb={20}>
                  <SubTitle>{category.name}</SubTitle>
                </Box>
                <CardFlex>
                  {R.pipe(
                    R.propOr([], 'links'),
                    R.map(link => (
                      <Box width={[1, 1 / 3]} px={4} pb={5} key={link.id}>
                        <Card target="_blank" height="120px" href={R.pathOr('', ['url'], link)}>
                          <Card.Meta title={link.name}>
                            <Link.Group>
                              <Link icon="LINK" as="span" />
                            </Link.Group>
                          </Card.Meta>
                        </Card>
                      </Box>
                    ))
                  )(category)}
                </CardFlex>
              </React.Fragment>
            ))(categories)
          )}
        </Flex>
      </Box>
    </Section>
  );
};

export default Links;
